import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Layout from "../Layout";
import List from "../Components/Installation/List";
import View from "../Components/Installation/View";
import { useSelector } from "react-redux";
import * as utils from "../Utils/comman";
import InstallationCertification from "../Components/Installation Certificate Ui/MainInstallationCertification";

function Installation() {
  const [comp, setComp] = useState("list");
  const [rowData, setRowData] = useState();
  const location = useLocation();
  const [currentOrder, setCurrentorder] = useState({});
  const primaryMenuRes = useSelector(
    (state) => state?.primaryMenu?.primaryMenu?.permissions
  );
  const [invertId, setInvertId] = useState("");

  useEffect(() => {
    setComp("list");
  }, [location]);

  function handleChange(newValue) {
    setComp(newValue.mode);
    setRowData(newValue.rowData);
  }

  function renderComponent() {
    switch (comp) {
      case "list":
        return (
          <List
            comp={comp}
            onChange={handleChange}
            rowData={rowData}
            setCurrentorder={setCurrentorder}
            setInvertId={setInvertId}
          />
        );
      case "view":
        return <View comp={comp} rowData={rowData} onChange={handleChange} />;

      case "installation":
        return (
          <InstallationCertification
            comp={comp}
            rowData={rowData}
            onChange={handleChange}
            invertId={invertId}
          />
        );
      // default:
      //   return (
      //     <Add
      //       comp={comp}
      //       rowData={rowData}
      //       onChange={handleChange}
      //       currentOrder={currentOrder}
      //     />
      //   );
    }
  }

  return (
    <Layout>
      <div className="main-content">
        <section className="section">
          <div className="section-header">
            <h1>Installation Certificate</h1>
          </div>
          {renderComponent()}
        </section>
      </div>
    </Layout>
  );
}

export default Installation;
